module.exports = __webpack_public_path__ + "img/title-5-a7497b.png";